import { DEFAULT_DENSITY, DEFAULT_REFERENCE_SIMILARITY } from "../../constants";
import { DEFAULT_2D_FORM_VALUES, FORM_FIELDS_2D } from "../2D/constants";
import {
  DEFAULT_PROMPT_EDIT_IMAGE_FORM_VALUES,
  FORM_FIELDS_PROMPT_EDIT_IMAGE,
} from "../PromptEditImage/constants";
import type { FormTypeCanvasCreate2D, FormTypeCanvasPromptEdit } from "./types";

export const FORM_FIELDS_CANVAS_CREATE = {
  ...FORM_FIELDS_2D,
  REFILL: "refill",
  CANVAS_SELECTION: "canvasSelection",
} as const;

export const DEFAULT_CANVAS_CREATE_FORM_VALUES: FormTypeCanvasCreate2D = {
  ...DEFAULT_2D_FORM_VALUES,
  [FORM_FIELDS_CANVAS_CREATE.REFILL]: false,
  [FORM_FIELDS_CANVAS_CREATE.CANVAS_SELECTION]: {
    type: "INIT_IMAGE",
    image: null,
    similarity: DEFAULT_REFERENCE_SIMILARITY,
    density: DEFAULT_DENSITY,
  },
};

export const FORM_FIELDS_CANVAS_PROMPT_EDIT = {
  ...FORM_FIELDS_PROMPT_EDIT_IMAGE,
  CANVAS_SELECTION: "canvasSelection",
  REFILL: "refill",
  DIMENSIONS: "dimensions",
} as const;

export const DEFAULT_CANVAS_PROMPT_EDIT_FORM_VALUES: FormTypeCanvasPromptEdit =
  {
    ...DEFAULT_PROMPT_EDIT_IMAGE_FORM_VALUES,
    [FORM_FIELDS_CANVAS_PROMPT_EDIT.REFILL]: false,
    [FORM_FIELDS_CANVAS_PROMPT_EDIT.DIMENSIONS]: [1024, 1024],
    [FORM_FIELDS_CANVAS_PROMPT_EDIT.CANVAS_SELECTION]: {
      type: "INIT_IMAGE",
      image: null,
      similarity: DEFAULT_REFERENCE_SIMILARITY,
      density: DEFAULT_DENSITY,
    },
  };
